export default __webpack_public_path__ + "static/media/IDFNord.12c5696a.jpg";